module.exports = __webpack_public_path__ + "93bd286c8360b6a7c2e2167847021dcd.pdf";